import * as React from 'react';
export class DropAreaRenderer extends React.PureComponent {
    render() {
        return React.createElement("div", { style: {
                position: 'fixed',
                top: this.props.dropArea.top,
                left: this.props.dropArea.left,
                width: this.props.dropArea.width,
                height: this.props.dropArea.height,
                backgroundColor: 'rgba(0, 0, 0, 0.5)'
            } });
    }
}
//# sourceMappingURL=drop-area-renderer.js.map